import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import OrderItem from '../Order/OrderItem'
import UserSelect from '../AppHeader/UserSelect'
import { EndIssueDTO } from '../../types/models/Issue'

type Props = {}

const CompleteOrder = observer((props: Props) => {
  const open = RootStore.modalsUi.completeOrder
  const order = RootStore.modalsUi.order

  const hundleClose = () => {
    RootStore.modalsUi.hundleCompleteOrder(false)
  }

  if (!order) return <></>

  const hundleChange = async () => {
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.completeOrder(order.id);

      toast.update(toastId, {
        render: 'Работа завершена',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <DialogTitle>Завершить заказ?</DialogTitle>
      <div>
        <DialogContent>
          {order ? <OrderItem order={order} noAction /> : null}
        </DialogContent>
      </div>

      <DialogActions>
        <Button onClick={hundleChange}>Завершить</Button>
        <Button onClick={hundleClose}>Отмена</Button>
      </DialogActions>
    </Dialog>
  )
})

export default CompleteOrder
